export default __webpack_public_path__ + "static/media/feb2.dee31284.jpg";